<template>
    <b-modal size="md" v-model="show" centered :title="'Fertigstellen: '+taskName"
    >
      <b-row>
        <b-col>
          <b-form-group
              class="mt-2"
              label="Fertigstellungsnachricht:"
          >
            <b-form-textarea
                class="text-black"
                rows="6"
                max-rows="40"
                wrap="hard"
                v-model="message"
                style="min-height: 150px; color: black"

            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
      <template #modal-footer="{ok, cancel}">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="md" variant="primary" @click="onCancel">
          Abbrechen
        </b-button>
        <b-button size="md" variant="success" @click="onFinish">
          Fertigstellen
        </b-button>
      </template>
    </b-modal>
</template>

<script>
export default {
  name: "FinishTaskDialog",
  data() {
    return {
      show: false,
      message: "",
      finishMessageMmDefault: "Ihre Kommune meldet, dass der von Ihnen gemeldete Mangel nun behoben ist.\nVielen Dank für Ihre Mithilfe.",
      taskName: "",
    }
  },
  methods: {
    onFinish() {
      this.show = false;
      this.$emit("finish-task", this.getReturnData());
    },
    onCancel() {
      this.show = false;
    },
    showDialog(taskName, isMm) {
      this.taskName = taskName;
      this.message = "";
      if (isMm) {
        this.message = this.finishMessageMmDefault;
      }
      this.show = true;
    },
    getReturnData: function () {
      return this.message;
    },
  }
}
</script>

<style>
.display_none {
  display: none;
}

.form-control:disabled {
  color: black;
}

.text-black {
  color: black;
}
</style>
